import script from "./EventStatic.vue?vue&type=script&setup=true&lang=js"
export * from "./EventStatic.vue?vue&type=script&setup=true&lang=js"

import "./EventStatic.vue?vue&type=style&index=0&id=4dc85cf0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc85cf0"]])

export default __exports__